export function getAllAssociateCompany(params, callbackSuccess, callbackError) {
  return {
    type: "GET_ALL_ASSOCIATE_COMPANY",
    payload: {
      params,
      callbackSuccess,
      callbackError,
    },
  };
}

export function setAllAssociateCompanySuccess(associatedCompanies) {
  return {
    type: "SET_ALL_ASSOCIATE_COMPANY",
    payload: {
      associatedCompanies,
    },
  };
}

export function getUserDocument(document, params, callbackSuccess, callbackError) {
  return {
    type: "GET_USER_DOCUMENT",
    payload: {
      document,
      params,
      callbackSuccess,
      callbackError,
    },
  };
}

export function createAssociateCompany(data, callbackSuccess, callbackError) {
  return {
    type: "CREATE_ASSOCIATE_COMPANY",
    payload: {
      data,
      callbackSuccess,
      callbackError,
    },
  };
}

export function removeAssociationCompany(
  serviceProviderId,
  params,
  callbackSuccess,
  callbackError,
) {
  return {
    type: "REMOVE_ASSOCIATE_COMPANY",
    payload: {
      serviceProviderId,
      params,
      callbackSuccess,
      callbackError,
    },
  };
}

export function updateLoginPermission(
  serviceProviderId,
  data,
  params,
  callbackSuccess,
  callbackError,
) {
  return {
    type: "UPDATE_LOGIN_PERMISSION",
    payload: {
      serviceProviderId,
      data,
      params,
      callbackSuccess,
      callbackError,
    },
  };
}

export function updateAssociateCompany(
  serviceProviderId,
  data,
  params,
  callbackSuccess,
  callbackError,
) {
  return {
    type: "UPDATE_ASSOCIATE_COMPANY",
    payload: {
      serviceProviderId,
      data,
      params,
      callbackSuccess,
      callbackError,
    },
  };
}
